import { ListItem, ListItemText, Stack, Typography } from "@mui/material";
import React from "react";
import {
  GFE_SERVICE_STATUS_ICON,
  mapToGfeChipType,
} from "@/components/common/gfe/gfeIndicationChip";
import { CamIcon } from "@/components/common/icons";
import { getVariablePricingCopy } from "@/components/serviceFlow/common/groupedServicesSelectionList";
import { PRIMARY } from "@/config/mui/colorPalette";
import { CategoriesWithClientIndicationsQuery } from "@/graphql/queries/categories.graphql.types";
import { AppointmentType } from "@/types";
import { formattedPrice } from "@/utils";

type ServiceOptionProps = {
  service: CategoriesWithClientIndicationsQuery["serviceCategory"][number]["medspaServiceMenuItems"][number];
} & React.HTMLAttributes<HTMLLIElement>;

export function ServiceOption({ service, ...props }: ServiceOptionProps) {
  const GfeIcon =
    GFE_SERVICE_STATUS_ICON[mapToGfeChipType[service.clientGfeIndication]];

  return (
    <ListItem
      component="li"
      sx={{
        gap: 0.5,
        justifyContent: "space-between !important",
        px: "24px !important",
        py: "8px !important",
      }}
      {...props}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <ListItemText sx={{ m: 0 }} primary={service.name} />
      </Stack>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <Typography color="text.secondary">
          {service.isVariablePricing
            ? getVariablePricingCopy(service.price)
            : formattedPrice(service.price)}
        </Typography>
        {service.appointmentType === AppointmentType.TELEHEALTH && (
          <CamIcon color={PRIMARY} />
        )}
        {GfeIcon && <GfeIcon />}
      </Stack>
    </ListItem>
  );
}
